const popup = {
  trigersToggle: [

    {
      name: 'menu-mobile',
      open: [document.getElementById('jsOpenMenu')] as HTMLElement[],
      popup: document.getElementById('jsMenuWrap') as HTMLElement,
      close: document.getElementById('jsCloseMenu') as HTMLElement,
      overlay: true,
    },

    {
      name: 'search',
      open: [document.getElementById('jsOpenSearch')] as HTMLElement[],
      popup: document.getElementById('jsSearchWrap') as HTMLElement,
      close: document.getElementById('jsCloseSearch') as HTMLElement,
      overlay: true,
    },

    {
      name: 'finder',
      open: [document.getElementById('jsOpenFinder')] as HTMLElement[],
      popup: document.getElementById('jsFinderWrap') as HTMLElement,
      close: document.getElementById('jsCloseFinder') as HTMLElement,
      overlay: true,
    },

    {
      name: 'finderDesk',
      open: [document.getElementById('jsOpenDeskFinder')] as HTMLElement[],
      popup: document.getElementById('jsFinderWrap') as HTMLElement,
      close: document.getElementById('jsCloseFinder') as HTMLElement,
      overlay: true,
    },

    {
      name: 'garage',
      open: [document.getElementById('jsGarageOpen')] as HTMLElement[],
      popup: document.getElementById('jsGarageWrap') as HTMLElement,
      close: document.getElementById('jsCloseGarage') as HTMLElement,
      overlay: true,
    },

    {
      name: 'garageDesk',
      open: [document.getElementById('jsGarageDeskOpen')] as HTMLElement[],
      popup: document.getElementById('jsGarageWrap') as HTMLElement,
      close: document.getElementById('jsCloseGarage') as HTMLElement,
      overlay: true,
    },

    {
      name: 'storeDesktop',
      open: [document.getElementById('jsOpenStore')] as HTMLElement[],
      popup: document.getElementById('jsStoreWrap') as HTMLElement,
      close: document.getElementById('jsCloseStore') as HTMLElement,
      overlay: true,
    },

    {
      name: 'storeFooter',
      open: [document.getElementById('jsOpenMap')] as HTMLElement[],
      popup: document.getElementById('jsStoreWrap') as HTMLElement,
      close: document.getElementById('jsCloseStore') as HTMLElement,
      overlay: true,
    },

    {
      name: 'filter',
      open: [document.getElementById('jsOpenFilter')] as HTMLElement[],
      popup: document.getElementById('jsFilterWrap') as HTMLElement,
      close: document.getElementById('jsCloseFilter') as HTMLElement,
      overlay: true,
    },

    {
      name: 'descriptionPopup',
      open: [document.getElementById('jsOpenDesc')] as HTMLElement[],
      popup: document.getElementById('jsDescriptionWrap') as HTMLElement,
      close: document.getElementById('jsCloseDescription') as HTMLElement,
      overlay: true,
    },

    {
      name: 'descriptionPopupDesktop',
      open: [document.getElementById('jsOpenDescDesk')] as HTMLElement[],
      popup: document.getElementById('jsDescriptionWrap') as HTMLElement,
      close: document.getElementById('jsCloseDescription') as HTMLElement,
      overlay: true,
    },

    {
      name: 'specificationPopup',
      open: [document.getElementById('jsSpecsOpen')] as HTMLElement[],
      popup: document.getElementById('jsSpecsWrap') as HTMLElement,
      close: document.getElementById('jsCloseSpecs') as HTMLElement,
      overlay: true,
    },

    {
      name: 'specificationPopup',
      open: [document.getElementById('jsSpecsOpenDesk')] as HTMLElement[],
      popup: document.getElementById('jsSpecsWrap') as HTMLElement,
      close: document.getElementById('jsCloseSpecs') as HTMLElement,
      overlay: true,
    },

    {
      name: 'partsPopup',
      open: [document.getElementById('jsOpenParts')] as HTMLElement[],
      popup: document.getElementById('jsPartsWrap') as HTMLElement,
      close: document.getElementById('jsPartsClose') as HTMLElement,
      overlay: true,
    },

    {
      name: 'partsPopup',
      open: [document.getElementById('jsOpenPartsDesk')] as HTMLElement[],
      popup: document.getElementById('jsPartsWrap') as HTMLElement,
      close: document.getElementById('jsPartsClose') as HTMLElement,
      overlay: true,
    },

        {
      name: 'FAQ',
      open: [document.getElementById('jsFaq')] as HTMLElement[],
      popup: document.getElementById('jsFaqWrap') as HTMLElement,
      close: document.getElementById('jsCloseFaq') as HTMLElement,
      overlay: true,
    },

    {
      name: 'FAQ desktop',
      open: [document.getElementById('jsFaqDesk')] as HTMLElement[],
      popup: document.getElementById('jsFaqWrap') as HTMLElement,
      close: document.getElementById('jsCloseFaq') as HTMLElement,
      overlay: true,
    },


    {
      name: 'stockLocation',
      open: [document.getElementById('JsOpenLocation')] as HTMLElement[],
      popup: document.getElementById('jsLocationWrap') as HTMLElement,
      close: document.getElementById('jsLocationClose') as HTMLElement,
      overlay: true,
    },

    {
      name: 'HaveAQuestionForm',
      open: [document.getElementById('jsOpenQForm')] as HTMLElement[],
      popup: document.getElementById('jsQuestionWrap') as HTMLElement,
      close: document.getElementById('jsCloseQuestion') as HTMLElement,
      overlay: true,
    },

    
    {
      name: 'PriceMatchForm',
      open: [document.getElementById('jsOpenPForm')] as HTMLElement[],
      popup: document.getElementById('jsPriceMWrap') as HTMLElement,
      close: document.getElementById('jsClosePriceM') as HTMLElement,
      overlay: true,
    },


        
    {
      name: 'Enquire',
      open: [document.getElementById('jsOpenEnquire')] as HTMLElement[],
      popup: document.getElementById('jsEnquireWrap') as HTMLElement,
      close: document.getElementById('jsCloseEnquire') as HTMLElement,
      overlay: true,
    },


    {
      name: 'Enquire Cart Line',
      open: [document.getElementById('jsOpenEnquireLine')] as HTMLElement[],
      popup: document.getElementById('jsEnquireWrap') as HTMLElement,
      close: document.getElementById('jsCloseEnquire') as HTMLElement,
      overlay: true,
    },
    
    
  ],

  overlay: document.getElementById('overlay')! as HTMLElement,
  close: document.querySelectorAll('.jsClose'),
  activClasse: [] as HTMLElement[],
  htmlEle: document.getElementById('head') as HTMLElement,
  

  init() {
    this.openPopupToggle()
    this.overlayClose()
    this.closeSecondary()
  },


  closeSecondary() {
  const  altClose = document.querySelectorAll('.jsAltClose'); 

  altClose.forEach(btn => {
    btn.addEventListener('click', () => {
      this.overlay.classList.remove('activeClass')
  this.htmlEle.classList.remove('activeClass')

      this.closeAll()
      
    });
  })
  
  },

  overlayClose() {
    this.overlay.addEventListener('click', () => {
      this.overlay.classList.remove('activeClass')
 this.htmlEle.classList.remove('activeClass')
      document.body.classList.remove('activeClass')
       this.htmlEle.classList.remove('activeClass')
      this.closeAll()
    })
  },

  setOverlay(
    open: HTMLElement | boolean,
    popup: HTMLElement | null,
    triger: HTMLElement,
    overlay = false,
  ) {
    if (open && popup && triger) {
      this.closeAll()
      this.overlay.classList.remove('activeClass')
      if (overlay) {
        this.overlay.classList.add('activeClass')
      }

  
      document.body.classList.add('activeClass')
       this.htmlEle.classList.add('activeClass')

      popup.classList.add('activeClass')
      triger.dataset.open = 'true'
      triger.classList.add('activeClass')
      this.activClasse.push(popup)
      this.activClasse.push(triger)
    } else {
      this.overlay.classList.remove('activeClass')
      triger.dataset.open = 'false'

      document.documentElement.style.overflow = 'hidden'
      document.body.classList.remove('activeClass')
 this.htmlEle.classList.remove('activeClass')
      this.closeAll()
    }
  },
  closeAll() {
    this.activClasse.forEach((item) => {
      item.classList.remove('activeClass')
      item.dataset.open = 'false'
    })
    this.activClasse = []
  },
  openPopupToggle() {
    this.trigersToggle.forEach((item, index) => {
      if (item['open'].length > 0) {
        item['open'].forEach((el) => {
         
          if (item['popup'] && el) {
            item['popup'].classList.add('init')
            el.addEventListener('click', (e) => {
              e.preventDefault()
              if (el.dataset.open === 'false') {
                this.setOverlay(true, item['popup'], el, item['overlay'])
              } else {
                this.setOverlay(false, item['popup'], el)
              }
            })
          }
        })

        if (item['close'] && typeof item['close'] === 'object') {
          item['close'].addEventListener('click', () => {
            item['open'].forEach((el: HTMLElement) => {
              this.setOverlay(false, item['popup'], el)
            })
          })
        }
      }
    })
  },
}

export default popup
